import { Sidebar } from "@rio-cloud/rio-uikit";
import FormLabel from "@rio-cloud/rio-uikit/FormLabel";
import { useEffect, type ComponentProps } from "react";
import { ExtractCallouts } from "./ExtractCallouts";
import { ExtractEventsTable } from "./ExtractEventsTable";
import { ExtractSummary } from "./ExtractSummary";
import { InfractionChart } from "./InfractionChart";
import { IdentifiedFailures } from "./IdentifiedFailures";
import { ExtractData } from "./types/types";

export type ExtractSidebarProps = ComponentProps<typeof Sidebar> & {
  data: ExtractData;
};

export function ExtractSidebar({ data, ...props }: ExtractSidebarProps) {
  

  return (
    <Sidebar
      title={
        <div className="padding-x-10 text-color-dark">
          Extrato para {data.assetName}
        </div>
      }
      fly
      makeBackdropVisible
      hasBackdrop
      resizable
      minWidth={360}
      maxWidth={1080}
      width={720}
      position={Sidebar.RIGHT}
      {...props}
    >
        <div>
          <div className="cq-container">
            <div className="padding-x-20">
              <ExtractSummary summary={data} />
            </div>
            <div className="padding-20 display-grid grid-cols-1 cq-700:grid-cols-2 gap-20">
              <div className="cq-700:col-span-full">
                <ExtractCallouts
                  normalizedScore={data.normalizedScore}
                  weightedScore={data.weightedScore}
                  scoreLabel={data.scoreLabel}
                />
              </div>
              <div>
                <FormLabel>
                  Proporção total do Índice de Conformidade Vs. Oportunidades de Melhoria
                  baseado em EPKs.
                </FormLabel>
                <InfractionChart epkScore={data.epkScore} />
              </div>
              <div>
                <FormLabel id="extract-label-identified-fails">
                  Falhas Identificadas e Impacto nos Componentes
                </FormLabel>
                <IdentifiedFailures failures={data.failures} />
              </div>
              <div className="height-300 cq-700:col-span-full">
                <FormLabel>Extrato de eventos</FormLabel>
                <ExtractEventsTable events={data.events} />
              </div>
            </div>
          </div>
        </div>
    </Sidebar>
  );
}
